import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { CrearVlanParametros } from '../shared/models/crear-vlan-parametros';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { SesionService } from '../shared/services/sesion.service';
import { CargandoComponent } from '../cargando/cargando.component';
import { environment } from '../../environments/environment';
import { ErrorDto } from '../shared/models/error-dto';
import { SuperNetService } from '../shared/services/supernet.service';
import { SuperNet } from '../shared/models/supernet';
import { BuscarSedeDto } from '../shared/models/buscar-sede-dto';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
import { ThrowStmt } from '@angular/compiler';
import { Sesion } from '../shared/models/sesion';
import { PermisoMenuDto } from '../shared/models/permiso-menu-dto';
@Component({
  selector: 'app-asignar-supernet-nube',
  templateUrl: './asignar-supernet-nube.component.html',
  styleUrls: ['./asignar-supernet-nube.component.css']
})
export class AsignarSupernetNubeComponent implements OnInit {


  principalForm = this.formBuilder.group({
    selectCompania: new FormControl('', Validators.required),
    selectCiudad: new FormControl('', Validators.required),
    selectSede: new FormControl('', Validators.required),
    selectMascara: new FormControl('', Validators.required),
    selectAmbiente: new FormControl('', Validators.required),
    imputIpInicial: ['', Validators.required],
    imputVlan: ['', Validators.required],
    textAreaObeservaciones: new FormControl('', Validators.required),
  });

  codigoListaMascaras = environment.listaCodigoMascara;
  companias: Compania[] = new Array<Compania>();
  companiasFiltro: Compania[];
  ciudades: Ciudad[];
  sedes: Sede[];
  sedesFiltradasParaCompania: BuscarSedeDto[] = new Array<BuscarSedeDto>();
  supernets: SuperNet[];
  mascaras: ListaItem[];
  ambientes: ListaItem[];
  idCompaniaSeleccionada: number;
  idCiudadSeleccionada: number;
  idSedeSeleccionada: number;
  sedeSeleccionada: Sede;
  idMascaraSeleccionada: number;
  superNet: SuperNet;
  nombreVlan: string;
  ipInicial: string;
  observaciones: string;
  parametros: CrearVlanParametros = new CrearVlanParametros();
  modalRef: NgbModalRef;
  mensajeAlerta: string;
  errorDto: ErrorDto = new ErrorDto();
  permisoCrearvlanSede: boolean;
  idAmbienteSelecccionado = -1;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sesionService: SesionService, private superNetService: SuperNetService) { }

  ngOnInit() {
    this.listarSuperNets();
    this.listarCompanias();
    this.listarCiudades();
    this.listarSedes();
  }

  public establecerDatosSuperNet(): void {
    this.companias == new Array<Compania>();
    this.ipInicial = this.superNet.ipInicialRango;
    this.idCiudadSeleccionada = this.superNet.idCiudad;
    this.idSedeSeleccionada = this.superNet.idSede;
    this.sedeSeleccionada = this.sedes.find(sede => sede.idSede === this.idSedeSeleccionada);
    this.sedeService.buscarSedes(this.idCiudadSeleccionada, this.sedeSeleccionada.nombreSede,
      [-1]).subscribe(
        resultado => {
          this.companias = new Array<Compania>();
          this.sedesFiltradasParaCompania = resultado;
          var arrayCompanias = this.sedesFiltradasParaCompania[0].companias.split(";");
          for (var arr in this.companiasFiltro) {
            for (var filter in arrayCompanias) {
              arrayCompanias[filter] = arrayCompanias[filter].trim();
              if (this.companiasFiltro[arr].nombreCompania === arrayCompanias[filter]) {
                this.companias.push(this.companiasFiltro[arr]);
              }
            }
          }
        }
      );

    this.listarMascaras();

  }
  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companiasFiltro = resultado
    );
  }

  public listarCiudades(): void {
    this.ciudadService.listarCiudades().subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public listarSedes(): void {
    this.sedeService.listarSedes().subscribe(
      resultado => this.sedes = resultado
    );
  }
  listarSuperNets(): void {
    this.superNetService.listarSuperNet().subscribe(
      resultadoSuperNet => {
        this.supernets = resultadoSuperNet
        this.supernets = this.supernets.filter(item => item.idCiudad===3);
      }
    );

  }
  public actualizarIpInicial(): void {
    var mascaraSeleccionada = this.mascaras.find(mascara => mascara.idListaItem == this.idMascaraSeleccionada);
    switch (mascaraSeleccionada.codigoItem) {
      case '17': {
        this.ipInicial = this.superNet.ipDiecisiete;
        break;
      }
      case '18': {
        this.ipInicial = this.superNet.ipDieciocho;
        break;
      }
      case '19': {
        this.ipInicial = this.superNet.ipDiecinueve;
        break;
      }
      case '20': {
        this.ipInicial = this.superNet.ipVeinte;
        break;
      }
      case '21': {
        this.ipInicial = this.superNet.ipVeintiuno;
        break;
      }
      case '22': {
        this.ipInicial = this.superNet.ipVeintidos;
        break;
      }
      case '23': {
        this.ipInicial = this.superNet.ipVeintitres;
        break;
      }
      case '24': {
        this.ipInicial = this.superNet.ipVeinticuatro;
        break;
      }
      case '25': {
        this.ipInicial = this.superNet.ipVeinticinco;
        break;
      }
      case '26': {
        this.ipInicial = this.superNet.ipVeintiseis;
        break;
      }
      case '27': {
        this.ipInicial = this.superNet.ipVeintisiete;
        break;
      }
      case '28': {
        this.ipInicial = this.superNet.ipVeintiocho;
        break;
      }
      case '29': {
        this.ipInicial = this.superNet.ipVeintinueve;
        break;
      }
      case '30': {
        this.ipInicial = this.superNet.ipTreinta;
        break;
      }

      default: {
        //statements; 
        break;
      }
    }
  }
  public listarMascaras(): void {
    this.listaItemService.listarMascarasConfiguradas().subscribe(
      resultado => {
        this.mascaras = resultado
        var arrayMascarasPermitidas = ['255.255.255.252',
          '255.255.255.248',
          '255.255.255.240',
          '255.255.255.224',
          '255.255.255.192',
          '255.255.255.128',
          '255.255.255.0',
          '255.255.254.0',
          '255.255.252.0',
          '255.255.248.0',
          '255.255.240.0',
          '255.255.224.0',
          '255.255.192.0',
          '255.255.128.0'
        ];
        var arrayNumeroAsociadoMascaras = ['30',
          '29',
          '28',
          '27',
          '26',
          '25',
          '24',
          '23',
          '22',
          '21',
          '20',
          '19',
          '18',
          '17']
        var arrayHosts = ['2',
          '6',
          '14',
          '30',
          '62',
          '126',
          '254',
          '510',
          '1022',
          '2046',
          '4094',
          '8190',
          '16382',
          '32766']
        this.mascaras = this.mascaras.filter(mascara => arrayMascarasPermitidas.indexOf(mascara.valorItem) !== -1)
        for (var posicion in this.mascaras) {
          var posicionMascara = arrayMascarasPermitidas.indexOf(this.mascaras[posicion].valorItem)

          this.mascaras[posicion].valorItem = '/' + arrayNumeroAsociadoMascaras[posicionMascara] + ' - ' + this.mascaras[posicion].valorItem + '- ' + arrayHosts[posicionMascara] + ' hosts'
          this.mascaras[posicion].codigoItem = arrayNumeroAsociadoMascaras[posicionMascara];

        }
        this.mascaras.sort((a, b) => a.codigoItem > b.codigoItem ? -1 : a.codigoItem < b.codigoItem ? 1 : 0)

      }
    );
  }

  public listarAmbientes(): void {
    this.idAmbienteSelecccionado = -1;
    this.listaItemService.ambientesPorCompaniaSedeValidaDMZ(this.idCompaniaSeleccionada,
      this.idSedeSeleccionada).subscribe(
        resultado => {
          this.ambientes = resultado
          this.idAmbienteSelecccionado = this.ambientes.find(ambiente => ambiente.idListaItem === this.superNet.idAmbiente).idListaItem

        }
      );
  }
  public guardarVlanSinRango(): void {
    swal({
      title: "Procesando",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)

    this.parametros.compania = new Compania();
    this.parametros.compania.idCompania = this.idCompaniaSeleccionada;
    this.parametros.idCiudad = this.idCiudadSeleccionada;
    this.parametros.idMascara = this.idMascaraSeleccionada;
    this.parametros.idSede = this.idSedeSeleccionada;
    this.parametros.ipInicial = this.ipInicial;
    this.parametros.nombreVlan = this.nombreVlan;
    this.parametros.observaciones = this.observaciones;
    this.parametros.idSuperNet = this.superNet.idSuperNet;
    this.parametros.idAmbiente=this.idAmbienteSelecccionado;

    this.administradorIpService.crearVlanSinRango(this.parametros).subscribe(

      resultado => {
        this.parametros = resultado;
        swal("Se creo correctamente", "La supernet fue creada para el rango : \n" + this.parametros.vlanCreada.ipInicialRango + " - " + this.parametros.vlanCreada.ipFinalRango, "success").then(function () {
          // Redirect the user
          window.location.href = "/#/solicitar-ip";
        });
      }, error => {
        this.errorDto = error.error;
        this.mensajeAlerta = this.errorDto.mensajeError;
        swal("Se presento un error", "" + this.mensajeAlerta, "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/asignar-supernet-nube/asignar-supernet-nube.component.ts